/**
 * @desc 获取地址树
 */
import { RegionEntity, RegionTreeQuery } from '@eastcoal/api/system/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryRegionTreeParameter = RegionTreeQuery

const method = 'GET'
const url = '/system/region/tree'

export const queryRegionTreeApi = (
  params?: QueryRegionTreeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<RegionEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryRegionTreeApi.method = method
queryRegionTreeApi.url = url
